import { NotificationDtoReadStatusEnum, NotificationDto } from '@interfaces/models';
import { DateFormatted, Typography, Markdown } from '@ui/components';
import { NotificationBadge } from '@pages/notifications/components';
import { Indicator } from '@ui/components/icons';
import { cn } from '@ui/utils';

interface NotificationsListItemProps {
  notification: NotificationDto;
}

export const NotificationsListItem = (props: NotificationsListItemProps) => {
  const { notification } = props;
  const { readStatus, createdAt, content, title, type } = notification;

  return (
    <div className="flex gap-4 items-start px-2">
      <div className="flex gap-4 items-type">
        <NotificationBadge severity={type} />
      </div>
      <section className="flex flex-col gap-1 w-full overflow-hidden">
        <Typography
          variant={
            readStatus === NotificationDtoReadStatusEnum.UNREAD
              ? 'paragraphBasicBold'
              : 'paragraphBasicBook'
          }
          className={cn({ 'text-default': readStatus === NotificationDtoReadStatusEnum.UNREAD })}
        >
          {title}
        </Typography>
        <Typography
          className={cn('text-weak text-wrap line-clamp-1', {
            'text-default': readStatus === NotificationDtoReadStatusEnum.UNREAD,
          })}
          variant="paragraphBasicBook"
          element="div"
        >
          <Markdown className="truncate">{content}</Markdown>
        </Typography>
        <div className="flex justify-between items-center mt-2">
          <div className="flex gap-2 items-center text-disabled">
            <Typography variant="labelSmallBook" asChild>
              <DateFormatted format="DATE_SHORT" date={createdAt} />
            </Typography>

            <Indicator />

            <Typography variant="labelSmallBook" asChild>
              <DateFormatted format="TIME_24_SIMPLE" date={createdAt} />
            </Typography>
          </div>
        </div>
      </section>
    </div>
  );
};
